import { parseISO } from "date-fns";
import { toZonedTime, format } from "date-fns-tz";

export const MAX_SUBMISSIONS = 20;

const DEFAULT_TIMEZONE = "Etc/UTC";

const getDefaultTimeZone = isoDate => {
  const date = parseISO(isoDate);
  return toZonedTime(date, DEFAULT_TIMEZONE);
};

export const formatRctpDate = (isoDate, formatStr) => {
  return format(getDefaultTimeZone(isoDate), formatStr);
};
